import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Subject } from 'rxjs';
import { WebcamModule } from 'src/app/shared-module/components/webcam/webcam.module';
import { environment } from 'src/environments/environment';

export interface ActionAttachmentVM{
  FileName: string;
  GUID?: string;
  MimeType?: string;
}

@Component({
  selector: 'app-action-assets',
  standalone: true,
  imports: [CommonModule, ButtonModule, WebcamModule],
  templateUrl: './action-assets.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './action-assets.component.scss'
})
export class ActionAssetsComponent {
  @Input() photos: string[] = [];
  @Input() attachments: ActionAttachmentVM[] = [];
  @Input() uploadingPhoto: boolean = false;
  @Input() uploadingAttachment: boolean = false;
  @Input() errorMessage: string = '';
  @Output() downloadAttachment = new EventEmitter<string>();
  @Output() downloadPhoto = new EventEmitter<string>();
  @Output() uploadAttachment = new EventEmitter<File>();
  @Output() uploadPhoto = new EventEmitter<File>();
  @Output() capturePhoto = new EventEmitter<string>();
  @Output() removeAttachment = new EventEmitter<{ guid: string; event: Event }>();
  @Output() removePhoto = new EventEmitter<{ guid: string; event: Event }>();

  showCamera: boolean = false;
  private trigger: Subject<void> = new Subject<void>();

  onDownload(guid: string){
    this.downloadAttachment.emit(guid);
  }

  onAttachmentSelected(event: Event){
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files.length ? input.files[0] : null;
    if (file){
      this.uploadAttachment.emit(file);
    }
    if (input){
      input.value = '';
    }
  }

  onPhotoSelected(event: Event){
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files.length ? input.files[0] : null;
    if (file){
      this.uploadPhoto.emit(file);
    }
    if (input){
      input.value = '';
    }
  }

  onRemove(guid: string, event: Event){
    if (!guid){ return; }
    this.removeAttachment.emit({ guid, event });
  }

  openCamera(){
    this.showCamera = true;
  }

  closeCamera(){
    this.showCamera = false;
  }

  takePicture(){
    this.trigger.next();
  }

  onCapture(base64: string){
    if (base64){
      this.capturePhoto.emit(base64);
    }
  }

  get triggerObservable(){
    return this.trigger.asObservable();
  }

  isImageAttachment(att: ActionAttachmentVM): boolean{
    const mime = (att?.MimeType || '').toLowerCase();
    if (mime.startsWith('image/')){
      return true;
    }
    const name = (att?.FileName || '').toLowerCase();
    return /\.(png|jpe?g|gif|bmp|webp|svg)$/.test(name);
  }

  attachmentSrc(guid?: string): string{
    if (!guid){ return ''; }
    return `${environment.apiUrl}actions/getattachment/${guid}`;
  }

  onDownloadPhoto(guid: string){
    this.downloadPhoto.emit(guid);
  }

  onRemovePhoto(guid: string, event: Event){
    this.removePhoto.emit({ guid, event });
  }
}
